// The one check for "the caller cancelled this request" (GROWTH-7384). It imports neither axios nor api/client, so a
// test that mocks ../api/client as a bare jest.fn() still gets the real check.
//
// axios 1.x rejects an aborted request with a CanceledError carrying code ERR_CANCELED, name CanceledError and the
// __CANCEL__ flag; an error that was re-wrapped may keep only one of them, and a legacy Cancel keeps only the flag.
export const isCanceledRequest = error => Boolean(error?.__CANCEL__ || error?.code === "ERR_CANCELED" || error?.name === "CanceledError");
